/**
 * Onglet Équipements : facilities + emplacements (CampPitch) + photos. Les relais sont des POI de
 * type « Abri / relais » depuis le 2026-10-26 ; les plans du site sont dans l'onglet Médias.
 */

import { OrganizationFacilitiesEditor } from './OrganizationFacilitiesEditor'
import { OrganizationPitchesEditor } from './OrganizationPitchesEditor'
import './OrganizationSiteAssetsEditor.css'

type Props = {
  organizationId: number
  defaultCenter?: [number, number]
}

export function OrganizationSiteAssetsEditor({ organizationId, defaultCenter }: Props) {
  return (
    <div className="org-site-assets">
      <OrganizationFacilitiesEditor
        organizationId={organizationId}
        defaultCenter={defaultCenter}
      />
      <hr className="org-site-assets__sep" />
      <OrganizationPitchesEditor
        organizationId={organizationId}
        defaultCenter={defaultCenter}
      />
    </div>
  )
}
